// extracted by mini-css-extract-plugin
module.exports = {"NavigationItem":"NavigationItem_NavigationItem__2BVaX","active":"NavigationItem_active__3h89T"};